module.exports = __webpack_public_path__ + "img/img_logo_wihte.136f0ad7.png";